import { useState } from 'react';
import { Home } from 'lucide-react';
import type { AuthenticatedSession } from './auth/types';
import { navigateWorkspaceHome } from './headquarters-site-navigation';

export function WorkspaceHomeButton({ session, onSelectScope, onHome }: {
  session: AuthenticatedSession;
  onSelectScope: (scopeId: string) => Promise<void>;
  onHome: () => void;
}) {
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);
  const goHome = async () => {
    if (pending) return;
    setPending(true); setFailed(false);
    try { await navigateWorkspaceHome(session, { selectScope: onSelectScope, closeFeature: onHome }); }
    catch { setFailed(true); }
    finally { setPending(false); }
  };
  return <>
    <button type="button" className="topbar-home" aria-label="홈" disabled={pending} onClick={() => void goHome()}>
      <Home size={20}/>
    </button>
    {failed && <span className="headquarters-site-switcher-error" role="alert">홈으로 돌아가지 못했습니다. 다시 시도해 주세요.</span>}
  </>;
}
